import SubcategoryPage from '@/components/template/SubcategoryPage';

const Portami = () => {
  const products = [
    {
      title: "Portami Classic",
      imageSrc: "https://images.unsplash.com/photo-1617104678098-de229db51175?auto=format&fit=crop&q=80",
      url: "/proizvodi/portami-classic"
    },
    {
      title: "Portami Modern",
      imageSrc: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80",
      url: "/proizvodi/portami-modern"
    },
    {
      title: "Portami Premium",
      imageSrc: "https://images.unsplash.com/photo-1617104678098-de229db51175?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/portami-premium"
    },
    {
      title: "Portami Deluxe",
      imageSrc: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/portami-deluxe"
    },
    {
      title: "Portami Minimal",
      imageSrc: "https://images.unsplash.com/photo-1617104678098-de229db51175?auto=format&fit=crop&q=80&w=1300",
      url: "/proizvodi/portami-minimal"
    },
    {
      title: "Portami Elegance",
      imageSrc: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80&w=1300",
      url: "/proizvodi/portami-elegance"
    }
  ];

  return (
    <SubcategoryPage
      title="Portami"
      description="Elegantni in praktični Portami izdelki, ki dodajo eleganten in funkcionalen pridih vašemu domu."
      heroImage="https://images.unsplash.com/photo-1617104678098-de229db51175?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Portami;